import React, { useState, useContext, useEffect, createContext } from "react";
import { auth } from "../firebase";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [userInfo, setUserInfo] = useState({});
  const [finalmonthlySalary, setFinalMonthlySalary] = useState(0);
  const [totalExpenses, setTotalExpenses] = useState(0);
  const [totalRevenue, setTotalRevenue] = useState(0);
  const [totalMargin, setTotalMargin] = useState(0);

  const signup = (email, password) =>
    auth.createUserWithEmailAndPassword(email, password);

  const signin = (email, password) =>
    auth.signInWithEmailAndPassword(email, password);

  const signout = () => auth.signOut();

  const resetPassword = (email) => auth.sendPasswordResetEmail(email);

  const updateEmail = (email) => currentUser.updateEmail(email);

  const updatePassword = (password) => currentUser.updatePassword(password);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setCurrentUser(user);
      setLoading(false);
    });
    return unsubscribe;
  }, []);

  const values = {
    currentUser,
    signin,
    signout,
    signup,
    resetPassword,
    updateEmail,
    updatePassword,
    userInfo,
    setUserInfo,
    finalmonthlySalary,
    setFinalMonthlySalary,
    totalExpenses,
    setTotalExpenses,
    totalMargin,
    setTotalMargin,
    totalRevenue,
    setTotalRevenue,
  };

  return (
    <AuthContext.Provider value={values}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
